import axios from "axios";
import { useState, useEffect } from "react";
import { BASE_URL } from "../constants/constants";
import styles from "../assets/css/Trips.module.css";
import Header from "../components/Header";
import List from "../components/List";

const Trips = () => {
  const [trips, setTrips] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 15;
  const [phoneNumber, setPhoneNumber] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [totalTripsCount, setTotalTripsCount] = useState(0);
  const [payment, setPayment] = useState("");

  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const getTrips = (page = 1) => {
    const params = {
      page,
      limit: itemsPerPage,
    };

    if (phoneNumber) params.phoneNumber = phoneNumber;
    if (firstName) params.firstName = firstName;
    if (lastName) params.lastName = lastName;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (payment) params.payment = payment;

    axios
      .get(`${BASE_URL}/v0/trip/all`, {
        headers,
        params,
      })
      .then((response) => {
        setTrips(response.data.result.Trips);
        setTotalPages(response.data.result.TotalPages);
        setTotalTripsCount(response.data.result.TripsCount);
      })
      .catch((error) => {
        console.error("There was an error fetching the trips!", error);
      });
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [phoneNumber, firstName, lastName, dateFrom, dateTo, payment]);

  useEffect(() => {
    getTrips(currentPage);
  }, [
    currentPage,
    phoneNumber,
    firstName,
    lastName,
    dateFrom,
    dateTo,
    payment,
  ]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const formatDuration = (duration) => {
    const match = duration.match(/(\d+)ч\s*(\d+)м\s*(\d+)с/);
    if (!match) return duration;

    const [, h, m, s] = match.map(Number);
    if (h === 0) {
      return `${m} мин ${s} сек`;
    }
    return `${h} ч ${m} мин ${s} сек`;
  };

const formatDate = (timestamp) => {
  const date = new Date(timestamp * 1000);
  return date.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, 
  });
};

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <List />
        <div className={styles.container1}>
          <div className={styles.box}>
            <div className={styles.text}>
              Все поездки <span>{totalTripsCount}</span>
            </div>
          </div>
          <div className={styles.filters}>
            <div className={styles.searchBlock}>
              <input
                className={styles.search}
                type="text"
                placeholder="Имя"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <input
                className={styles.search}
                type="text"
                placeholder="Фамилия"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              <input
                className={styles.search}
                type="text"
                placeholder="+7"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </div>
            <div className={styles.filterBlock}>
              <div className={styles.searchDate}>
                <div className={styles.placeholder}>Дата от:</div>
                <input
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </div>
              <div className={styles.searchDate}>
                <div className={styles.placeholder}>Дата до:</div>
                <input
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </div>
              <div className={styles.searchDate}>
                <div className={styles.placeholder}>Тип платежа:</div>
                <select
                  value={payment}
                  onChange={(e) => setPayment(e.target.value)}
                >
                  <option value="">Все</option>
                  <option value="CASH">Наличные</option>
                  <option value="CARD">Карта</option>
                </select>
              </div>
            </div>
          </div>

          <div className={styles.container2}>
            {trips.map((trip) => (
              <div key={trip.id} className={styles.wrapper}>
                <div className={styles.block}>
                  <div className={styles.nameBlock}>
                    <div className={styles.name}>
                      <span>Пассажир:</span>{" "}
                      {trip.passenger.lastName || "Не указано"}{" "}
                      {trip.passenger.firstName || "Не указано"}
                    </div>
                    <div className={styles.name}>
                      <span>Водитель:</span>{" "}
                      {trip.driver.lastName || "Не указано"}{" "}
                      {trip.driver.firstName || "Не указано"}
                    </div>
                  </div>
                  <div className={styles.phoneBlock}>
                    <div className={styles.phone}>
                      {trip.passenger.phoneNumber}
                    </div>
                    <div className={styles.phone}>
                      {trip.driver.phoneNumber || "Не указано"}
                    </div>
                  </div>
                  <button className={styles.adminbtn}>
                    <div className={styles.cost}>{trip.cost} ₸</div>
                    <div className={styles.cost}>
                      {trip.paymentType === "CASH"
                        ? "Наличные"
                        : trip.paymentType === "CARD"
                        ? "Карта"
                        : "Неизвестно"}
                    </div>
                  </button>
                </div>
                <div className={styles.addressBlock}>
                  <div className={styles.address}>
                    {trip.startAddress} ──▶ {trip.endAddress}
                  </div>
                  <div className={styles.date}>
                    <div className={styles.duration}>
                      Время поездки: {formatDuration(trip.duration)}
                    </div>
                    <div className={styles.duration}>
                      Дата поездки: {formatDate(trip.createdAt)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.block1}>
            <div className={styles.paginate}>
              <div className={styles.box3}>
                <img
                  className={styles.paginationicons}
                  src="/images/left.svg"
                  alt="left icon"
                  onClick={() => handlePageChange(currentPage - 1)}
                />
              </div>
              <div className={styles.page}>
                {currentPage} / {totalPages}
              </div>
              <div className={styles.box4}>
                <img
                  className={styles.paginationicons}
                  src="/images/right.svg"
                  alt="right icon"
                  onClick={() => handlePageChange(currentPage + 1)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Trips;
